import React from "react";
import { Link } from "react-router-dom";
import "./EngineeringReliableSilicon.css";

import img17 from "../../images/service/img17.png";
import img18 from "../../images/service/img18.png";
import img19 from "../../images/service/img19.png";
import img20 from "../../images/service/img20.png";

const EngineeringReliableSilicon: React.FC = () => {
  // === Reusable Arrow SVG ===
  const ArrowIcon = () => (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6.12842"
        y="21.8882"
        width="22.7911"
        height="2.8941"
        transform="rotate(-40.2798 6.12842 21.8882)"
        fill="#B794FF"
      />
      <rect
        x="9.34692"
        y="7.78027"
        width="2.8941"
        height="2.8941"
        transform="rotate(-40.2798 9.34692 7.78027)"
        fill="#B794FF"
      />
      <rect
        x="13.4258"
        y="8.11658"
        width="2.8941"
        height="2.8941"
        transform="rotate(-40.2798 13.4258 8.11658)"
        fill="#B794FF"
      />
      <rect
        x="17.5046"
        y="8.45337"
        width="2.8941"
        height="2.8941"
        transform="rotate(-40.2798 17.5046 8.45337)"
        fill="#B794FF"
      />
      <rect
        x="21.2471"
        y="12.8689"
        width="2.8941"
        height="2.8941"
        transform="rotate(-40.2798 21.2471 12.8689)"
        fill="#B794FF"
      />
      <rect
        x="20.9109"
        y="16.9485"
        width="2.8941"
        height="2.8941"
        transform="rotate(-40.2798 20.9109 16.9485)"
        fill="#B794FF"
      />
      <rect
        x="20.5735"
        y="21.0273"
        width="2.8941"
        height="2.8941"
        transform="rotate(-40.2798 20.5735 21.0273)"
        fill="#B794FF"
      />
    </svg>
  );

  // === Engineering Service Data ===
  const serviceItems = [
    {
      img: img17,
      title: "Engineering Discipline",
      description:
        "Structured processes that ensure consistency, quality, and execution excellence.",
    },
    {
      img: img18,
      title: "Technical Expertise",
      description:
        "Deep domain knowledge across design, verification, physical design, DFT, and silicon realization.",
    },
    {
      img: img19,
      title: "Collaborative Execution",
      description:
        "Seamless integration with customer engineering teams through transparent communication and shared ownership.",
    },
    {
      img: img20,
      title: "Reliable Outcomes",
      description:
        "Delivering dependable engineering results that contribute to successful silicon development.",
    },
  ];

  return (
    <section id="service" className="service pt-30">
      <div className="container-fluid">
        <div className="ai-service-wrap sec-border mlr-20">

          {/* === Heading Section === */}
          <div className="ai-service-heading ul_li_between mb-60 mt-40">
            <div className="sec-title-three">
              <span className="sub-title mb-25">
                SILICON ENGINEERING
              </span>

              <h2 className="title xb-text-reveal">
                Engineering Reliable Silicon
              </h2>
            </div>

            <p className="content">
              Reliable silicon is an outcome of disciplined engineering,
              structured execution, and uncompromising attention to detail.
              At Digicomm Semiconductor, every engagement is guided by proven
              engineering methodologies, collaborative execution, and a
              commitment to quality across every stage of the semiconductor
              development lifecycle.
            </p>
          </div>

          {/* === Image Service Items === */}
          <div className="ai-service-img">
            {serviceItems.map((item, index) => (
              <div
                key={index}
                className="ai-service-img-item wow fadeInLeft"
                data-wow-delay={`${index * 150}ms`}
                data-wow-duration="600ms"
              >
                {/* Image */}
                <div className="img">
                  <img src={item.img} alt={item.title} />
                </div>

                {/* Content */}
                <div className="ai-img-content">
                  <h4 className="title">
                    {item.title}
                  </h4>

                  <p className="content">
                    {item.description}
                  </p>

                  <Link
                    to="/service-details"
                    className="arrow"
                    aria-label={`Learn more about ${item.title}`}
                  >
                    <ArrowIcon />
                  </Link>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default EngineeringReliableSilicon;